

export const mapCurrencyResponse = (resp) => {
  if (!Array.isArray(resp)) return [];

  return resp.map((c) => ({
    id: { id: c.currencyId, name: c.currencyCode } || "",
    name: c.currencyCode,
    currencyValue: c.currencyValue,
  }));
};

export const mapExchangeDetails = (resp) => ({
  id:
    { id: resp.exchangeRateMasterId, name: resp.exchangeRateCurrencyCode } ||
    "",
  name: resp.exchangeRateCurrencyCode || "",
  description: resp.exchangeRateCurrencyName || "",
  unit: resp.exchangeRateCurrencyUnit || "",
  rate: resp.exchangeRateExportRate || "",
  importrate:resp.exchangeRateImportRate || "",
});

// Mapping for port details
export const mapPortDetails = (resp) => ({
  id: { id: resp.id, name: resp.portName } || "",
  name: resp.portName || "",
  description: resp.portCode || "",
  portCode: resp.portCode || "",
  countryId: resp.countryId || "",
  portCountryName: { id: resp.countryId, name: resp.portCountryName } || "",
});

export const mapGatewayDetails = (resp) => {

return {
    id: resp.gatewayPortId || "",
  name: resp.gatewayName || "",
  description: resp.gatewayUNECECode || "",
  // value : resp.gatewayPortId || "",
  portType: resp.gatewayPortType || "",
  state: resp.gatewayPortState || "",
}
};

export const mapShipLineDetails = (resp) => {

return {
    id: resp.shippingLineId || "",
  name: resp.shippingLineName || "",
  description: resp.shippingLineCode || "",
  // value : resp.gatewayPortId || "",
  portType: resp.gatewayPortType || "",
  state: resp.gatewayPortState || "",
}
};

export const mapQuantityDetails = (resp) => ({
  id: { id: resp.quantityId, name: resp.quantityCode } || "",
  name: resp.quantityCode || "",
  description: resp.quantityDescription || "",
  ISO: resp.quantityEDICode || "",
  status: resp.quantityStatus || "",
  state: resp.cfsState || "",
});

export const maAirlineDetails = (resp) => {
  return {
    id: { id: resp.airLineId, name: resp.airLineName } || "",
    name: resp.airLineName || "",
    code: resp.airLineCode || "",
    prefix:resp.airLinePrefix || "",
  };
};

export const maVolumeDetails = (resp) => ({
  id: { id: resp.volumeId, name: resp.volumeCode } || "",
  name: resp.volumeCode || "",
  description: resp.volumeDescription || "",
});

export const mapIECodeDetails = (resp) => ({
  id: { id: resp.id, name: resp.ieCode } || "",
  name: resp.ieCode || "",
  description: resp.organisationName || "",
});

export const mapCFSDetails = (resp) => ({
  id: { id: resp.id, name: resp.cfsName } || "",
  name: resp.cfsName || "",
  description: resp.cfsCode || "",
  type: resp.cfsType || "",
  city: resp.cfsCity || "",
});

// Mapping for country details
export const mapCountryDetails = (resp) => {
  return {
    id: resp.id,
    name: resp.countryName || "",
    description: resp.countryCode || "",
    ISO: resp.countryISO3 || "",
    status: resp.countryStatus || "",
  };
};

// export const mapCityDetails = (resp) => ({
//   id: { id: resp.cityId, name: resp.cityName } || "",
//   name: resp.cityName || "",
//   pinCode: resp.cityPinCode || "",
//   status: resp.cityStatus || "",
//   stateId: resp.stateId || "",
//   stateName: resp.stateName || "",
//   createdBy: resp.cityCreatedBy || "",
//   updatedBy: resp.cityUpdatedBy || "",
//   entryDate: resp.cityEntryDate || "",
//   updateDate: resp.cityUpdateDate || "",
// });
export const mapCityDetails = (resp) => {
  return {
    id: { id: resp.cityId, name: resp.cityName },
    name: resp.cityName || "",
    pinCode: resp.cityPinCode || "",
    status: resp.cityStatus || "",
    stateId: resp.stateId || "",
    stateName: resp.stateName || "",
    createdBy: resp.cityCreatedBy || "",
    updatedBy: resp.cityUpdatedBy || "",
    entryDate: resp.cityEntryDate || "",
    updateDate: resp.cityUpdateDate || "",
  };
};

export const mapImportInvoice = (resp) => {
  return { 
      id : {id : resp.importInvoiceId , name : resp.importInvoiceNumber}|| "",
      name : resp.importInvoiceNumber || "",
      description : resp.code || "",
     
  }
};

export const mapDesciptionMaster = (resp) => ({
  id: { id: resp.descriptionId, name: resp.description } || "",
  name: resp.description || "",
  ProductGroup: resp.descriptionProductGroup || "",
  description: resp.descriptionMaterialCode || "",
  status: resp.descriptionStatus || "",
  hsCode: resp.descriptionHSCode || "",
  createdBy: resp.descriptionCreatedBy || "",
  updatedBy: resp.descriptionUpdatedBy || "",
  entryDate: resp.cityEntryDate || "",
  updateDate: resp.cityUpdateDate || "",
});
export const mapHsnCodeMaster = (resp) => {
  return {
    id: { id: resp.hsCodeId, name: resp.hsCode } || "",
  name: resp.hsCode || "",
  description: resp.hsCodeDescription || "",
  hsCodeStandardUnit: resp.hsCodeStandardUnit || "",
  hsCodeDutyRate: resp.hsCodeDutyRate || "",
  hsCodeTariffType: resp.hsCodeTariffType || "",
  sourcePage: resp.sourcePage || "",
  status: resp.hsCodeStatus || "",
  entryDate: resp.hsCodeEntryDate || "",
  updateDate: resp.hsCodeUpdateDate || "",
  }
  
};

export const mapQualifierCode = (resp) => {
  return {
    id : {id :resp?.qualifierCodeId,name : resp?.qualifier } || "",
    name : resp?.qualifier || "",
    description : resp?.qualifierCode || "",
    qualifier : resp?.qualifier || "",
    qualifierCode : resp?.qualifierCode || "",
    qualifierDataCategory : resp?.qualifierDataCategory || "",
    qualifierCodeMasterStatus : resp?.qualifierCodeMasterStatus || "",
    qualifierCodeMasterEntryDate : resp?.qualifierCodeMasterEntryDate || "",
    qualifierCodeMasterUpdateDate : resp?.qualifierCodeMasterUpdateDate || "",
  }
}

export const mapEsanchitDocumentType = (resp) => {
  return {
    id: { id: resp.documentId, name: resp.documentName } || "",
    name: resp.documentName || "",
    description: resp.documentCode || "",
    status: resp.documentStatus || "",
  };
};

export const mapEndUseCodeMaster = (resp) => {
  return {
    id: { id: resp.enduseCodeId, name: resp.endUseCode } || "",
    name: resp.endUseCode || "",
    description: resp.endusecodeDescription || "",
    status: resp.endusecodeStatus || "",
    entryDate: resp.endusecodeEntryDate || "",
    updateDate: resp.endusecodeUpdateDate || "",
  };
};
export const mapStateMaster = (resp) => {
  return {
    id: resp.id || "",
    countryId: resp.countryId || "",
    countryName: resp.countryName || "",
    name: resp.stateName || "",
    stateCode: resp.stateCode || "",
    status: resp.stateStatus || "",
    createdBy: resp.stateCreatedBy || "",
    updatedBy: resp.stateUpdatedBy || "",
    entryDate: resp.stateEntryDate || "",
    updateDate: resp.stateUpdateDate || "",
  };
};

export const mapCurrencyMaster = (resp) => ({
  id: resp.exchangeCurrencyMasterId || "",
  exchangeCurrencyId: resp.exchangeCurrencyId || "",
  exchangeCurrencyGuid: resp.exchangeCurrencyGuid || "",
  exchangeCurrencyCode: resp.exchangeCurrencyCode || "",
  exchangeCurrencyName: resp.exchangeCurrencyName || "",
  exchangeCurrencyExrate: resp.exchangeCurrencyExrate || "",
  exchangeCurrencyDecname: resp.exchangeCurrencyDecname || "",
  status: resp.exchangeCurrencyStatus || "",
  createdBy: resp.exchangeCurrencyCreatedBy || "",
  updatedBy: resp.stateUpdatedBy || "",
  entryDate: resp.stateEntryDate || "",
  updateDate: resp.stateUpdateDate || "",
});

export const mapFTAMaster = (resp) => {
  return {
    id: resp.ftaInfoId || "",
    name: resp.ftaInfoCode || "",
    ftaInfoDate: resp.ftaInfoDate || "",
    ftaInfoNameOfAgreement: resp.ftaInfoNameOfAgreement || "",
    status: resp.ftaInfoStatus || "",
    entryDate: resp.ftaInfoEntryDate || "",
    updateDate: resp.ftaInfoUpdateDate || "",
  };
};

export const mapExchangeMaster = (resp) => {
  return {
    id:
      { id: resp.exchangeRateMasterId, name: resp.exchangeRateCurrencyCode } ||
      "",
    name: resp.exchangeRateCurrencyCode || "",
  };
};


export const mapRateMaster = (resp) => {
  return {
    id: { id: resp.rateListId, name: resp.rate } || "",
    name: resp.rate || "",
    description: resp.capvalue || "",
    code: resp.itemCode || "",
    entryDate: resp.rateListEntryDate || "",
    updateDate: resp.rateUpdateDate || "",
  };
};


export const mapDistrictMaster = (resp) => {
  return {
    id: { id: resp.districtId, name: resp.districtName } || "",
    name: resp.districtName || "",
    stateId: resp.stateId || "",
    stateName: resp.stateName || "",
    districtCode: resp.districtCode || "",
    status: resp.districtStatus || "",
    entryDate: resp.districtEntryDate || "",
    updateDate: resp.districtUpdateDate || "",
  };
};

// Mapping for country details
export const mapDrawer = (resp) => ({
  id: resp.drawbackId || "",
  name: resp.srNo || "",
  rate: resp.dbkRate || "",
  dbkcap: resp.dbkCap || "",
  description: resp.dbkDescription || "",
  dbkunit: resp.dbkUnit || "",
});

export const mapVolumeDetails = (resp) => ({
  id: { id: resp.volumeId, name: resp.volumeCode } || "",
  name: resp.volumeCode || "",
  description: resp.volumeDescription || "",
  ISO: resp.volumeUNECECode || "",
  status: resp.volumeStatus || "",
});
export const mapCustomeHouse = (resp) => ({
  id: { id: resp.customHouseId, name: resp.customHouseCode } || "",
  name: resp.customHouseCode || "",
  description: resp.customHouseName || "",
  status: resp.customHouseStatus || "",
});
export const mapInvoiceMain = (resp) => ({
  id: { id: resp.importInvoiceId, name: resp.importInvoiceNumber } || "",
  name: resp.importInvoiceNumber || "",
  Date: resp.importInvoiceDate || "",
  status: resp.customHouseStatus || "",
});

export const mapAdCodeMaster = (res) =>{
  return {
    id : {id : res.adCodeId , name : res.adCodeName}|| "",
    name : res.adCodeName || "",
    description : res.adCodeValue || "",
  }
};

export const mapCustomerType = (res) =>{
  return {
    id :  res.id || "",
    name : res.customerUserRole || "",
  }
}
export const mapCustomerDetails = (res) =>{
  return {
    id :  res.customerId || "",
    name : res.customerName || "",
  }
}
export const mapShipingLine = (resp) => {
  return {
    id: { id: resp.shippingLineId, name: resp.shippingLineName } || "",
    name: resp.shippingLineName || "",
    code: resp.shippingLineCode || ""
   
  };
};


export const mapContactDetails = (resp) => {
  return {
    id: resp.customerContactId || "",  // fallback
    name: resp.contactName || "",                                 
  };
};


export const mapEximDetails = (resp) => {
  return {
    id: resp.schemeMasterId || "",
    name:resp.schemeDescription || "",
  };
};
export const mapNotation = (resp) => {
  return {
    id: resp.notationMasterId || "",
    name:resp.notationSerialNumber || "",
    notation:resp.notation || "",
    rate:resp.rate || "",
  };
};
